import { CountUp } from "../CountUp";
import { Table } from "../Table";

interface CustomerTableProps {
  isLoading?: boolean;
  data?: any[];
}

export function CustomerTable(props: CustomerTableProps) {
  const { isLoading, data } = props;

  return (
    <Table
      isLoading={isLoading}
      toolbar={false}
      columnsButton
      pageSize={7}
      columns={[
        { title: "Nome", field: "nome" },
        { title: "Destinatário", field: "destinatario" },
        { title: "Status", field: "status_envio_externo" },
        {
          title: "Ticket médio",
          field: "ticket_medio",
          render: (row) => (
            <CountUp
              end={Number(row?.ticket_medio)}
              prefix="R$"
              decimals={2}
              start={0}
            />
          ),
        },
      ]}
      data={data}
    />
  );
}
